import styled from "styled-components";
import Overlay from "../../../Componentes/Overlay"
import Modal from "../../../Componentes/Utils/Modal"
import Tabela from "../../../Componentes/Utils/Tabela";
import { useModal } from "../../../contexts/ModalContext";
import ModalAddChecklistTipo from "./ModalAddCheckListTipo";
import { useEffect, useState } from "react";
import ModalListaModelos from "./ModalListaModelos";
import ModalListaItens from "./ModalListaItens";
import ModalDeleteTipo from "./ModalDeleteTipo"
import { MdEdit } from "react-icons/md";
import { GoTrash } from "react-icons/go";

import useApi from "../../../hooks/useApi";
const BotaoAddTipo = styled.button`
    width: 200px;
    height: 40px;
    background-color: #4CAF50;
    color: white;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    border: none;
    border-radius: 5px;
    transition: .3s;
    &:hover {
        background-color: #45a049;
        scale: 1.05;
    }
    margin-left: auto;
    margin-bottom: 10px;
`
const ColunaTabela = styled.td`
    color: black;
`
const StatusDiv = styled.div`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${ props => props.modelos ? "green" : "red" };
    margin: auto;
`
const ColunaItens =styled.td`
    width: 120px;
`
const DivAcoes = styled.div`
    width: 100%;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
`
const IconeEdit = styled(MdEdit)`
    width: 22px;
    height: 22px;
    color: #0000ff;
    cursor: pointer;
    transition: all.3s;
    &:hover{
        scale: 1.1;
    }
`
const IconeApagar = styled(GoTrash)`
    width: 20px;
    height: 20px;
    color: #ff0000;
    cursor: pointer;
    transition: all.3s;
    &:hover{
        scale: 1.1;
    }
`

const ModalChecklistTipos = () => {
    const api = useApi();


    const { closeModal, openModal, isModalOpen } = useModal();

    const [ editItem, setEditItem ] = useState( null );

    const openModalNewTipo = ( item = null ) => {
        setEditItem( item );
        openModal('modalAddTipo')
    }

    const openModalDeleteTipo = ( item = null ) => {
        setEditItem( item );
        openModal('modalDeleteTipo');
    }

    const closeModalNewTipo = () => {
        setEditItem(null);
        closeModal();
    }

    const [ tiposList, setTiposList ] = useState([])
    const [ loading, setLoading ] = useState( true );

    const fetchTipos = async () => {

        setLoading( true );

        try{
            const { data } = await api.get('/Painel/API/Checklist/GetTipos/')
            setTiposList( data );
        }catch( e ){
            console.error( e );
        }finally{
            setLoading( false );
        }

    }

    useEffect(() => {
        fetchTipos();
    }, [])

    const [ tipoIdSelected, setTipoIdSelected ] = useState( null );

    const openModalTabela = ( item ) => {

        console.log( item )

        setTipoIdSelected( item.identifier )

        if( item.modelos ){
            openModal('modalListaModelos')
        }else{
            openModal('modalListaItens')
        }
    }

    return (
        <>
            <Overlay state={true} >
                <Modal header={true} size="xl" close={closeModal} >
                    <BotaoAddTipo onClick={() => openModalNewTipo()} >NOVO TIPO</BotaoAddTipo>
                    <Tabela loading={ loading } >
                        <thead>
                            <tr>
                                <th>TIPO CHECKLIST</th>
                                <th>POSSUÍ MODELOS ?</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {tiposList.map(obj => (
                                <tr
                                    key={obj.identifier}
                                    onClick={() => openModalTabela( obj )}
                                >
                                    <ColunaTabela>{obj.nome}</ColunaTabela>
                                    <td>
                                        <StatusDiv modelos={ obj.modelos } />
                                    </td>
                                    <ColunaItens>
                                        <DivAcoes>
                                            <IconeEdit onClick={(e) => {
                                                e.stopPropagation();
                                                openModalNewTipo( obj )
                                            }} />
                                            <IconeApagar onClick={(e) => {
                                                e.stopPropagation();
                                                openModalDeleteTipo( obj );
                                            }} />
                                        </DivAcoes>
                                    </ColunaItens>
                                </tr>
                            ))}
                        </tbody>
                    </Tabela>
                </Modal>
            </Overlay>
            {isModalOpen('modalAddTipo') && (
                <ModalAddChecklistTipo
                    item={ editItem }
                    fetchSuccess={ fetchTipos }
                    fecharModal={ closeModalNewTipo }
                />
            )}
            {isModalOpen('modalDeleteTipo')&&(
                <ModalDeleteTipo
                    item={ editItem }
                    fetchSuccess={ fetchTipos }
                    fecharModal={ closeModalNewTipo }
                />
            )}
            {isModalOpen('modalListaModelos')&&(
                <ModalListaModelos
                    id_tipo={ tipoIdSelected }
                />
            )}
            {isModalOpen('modalListaItens')&&(
                <ModalListaItens
                    origem="tipo"
                    id_tipo={ tipoIdSelected }
                />
            )}
        </>
    )
}

export default ModalChecklistTipos;